import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

export default function Hero() {
  const { t } = useTranslation();

  const trustBadges = [
    { icon: "ri-checkbox-circle-line", text: t("hero.trust.1") },
    { icon: "ri-book-open-line", text: t("hero.trust.2") },
    { icon: "ri-shield-check-line", text: t("hero.trust.3") },
    { icon: "ri-global-line", text: t("hero.trust.4") },
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Modern%20bright%20workspace%20with%20laptop%20showing%20product%20catalog%20on%20screen%2C%20surrounded%20by%20neatly%20arranged%20fashion%20items%20including%20sneakers%20and%20a%20denim%20jacket%2C%20soft%20natural%20morning%20light%20from%20large%20window%2C%20warm%20cream%20and%20oatmeal%20color%20palette%2C%20Scandinavian%20minimalist%20interior%20design%2C%20clean%20aesthetic%20with%20a%20small%20potted%20olive%20tree%2C%20editorial%20lifestyle%20photography%20with%20bright%20airy%20atmosphere&width=1800&height=1200&seq=hero-bg-v3-main&orientation=landscape)`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/25"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 py-20">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 bg-primary-500/90 text-background-50 text-xs md:text-sm font-medium rounded-full mb-6">
            Kakobuy Spreadsheet 2026
          </span>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            {t("hero.title")}
            <br />
            <span className="text-primary-300">{t("hero.subtitle")}</span>
          </h1>

          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
            {t("hero.description")}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-sm md:text-base transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {t("hero.cta.primary")} <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white font-semibold rounded-lg border border-white/30 text-sm md:text-base transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {t("hero.cta.secondary")} <i className="ri-shopping-bag-line ml-2"></i>
            </a>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
            {trustBadges.map((badge, idx) => (
              <div
                key={idx}
                className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-lg px-3 py-2.5 border border-white/15"
              >
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className={`${badge.icon} text-primary-300 text-lg`}></i>
                </div>
                <span className="text-xs md:text-sm text-white/90 font-medium text-left leading-tight">
                  {badge.text}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
        </div>
      </div>
    </section>
  );
}